import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

export default function useKallitagLeads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const { data } = await api.get("/kallitag-leads", { params: { limit: 100 } });
      setLeads(data.leads || []);
    } catch (err) {
      setError(err.response?.data?.detail || "Impossible de charger les leads Kallitag");
      setLeads([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { leads, loading, error, refresh };
}
